  // {
  //   menutitle: "General",
  //   menucontent: "Dashboards,Widgets",
  //   Items: [
  //     {
  //       title: "Dashboard",
  //       icon: "home",
  //       type: "sub",
  //       badge: "badge badge-light-primary",
  //       badgetxt: "5",
  //       active: false,
  //       children: [
  //         { path: `${process.env.PUBLIC_URL}/dashboard/default`, title: "Default", type: "link" },
  //         { path: `${process.env.PUBLIC_URL}/dashboard/e-commerce`, title: "E-commerce", type: "link" },
  //         { path: `${process.env.PUBLIC_URL}/dashboard/online-course`, title: "Online Course", type: "link" },
  //         { path: `${process.env.PUBLIC_URL}/dashboard/crypto`, title: "Crypto", type: "link" },
  //         { path: `${process.env.PUBLIC_URL}/dashboard/social`, title: "Social", type: "link" },
  //       ],
  //     },

  //     {
  //       title: "Widgets",
  //       icon: "widget",
  //       type: "sub",
  //       active: false,
  //       children: [
  //         { path: `${process.env.PUBLIC_URL}/widgets/general`, title: "General", type: "link" },
  //         { path: `${process.env.PUBLIC_URL}/widgets/chart`, title: "Chart", type: "link" },
  //       ],
  //     },
  //   ],
  // },
export const MENUITEMS = [
  {
    Items: [
      {
        title: "dashboard",
        icon: "home",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/dashboard`,
      },
    ],
  },
  {
    menutitle: "operations",
    menucontent: "Reservations,Transactions,Devices",
    Items: [
      {
        title: "reservations",
        icon: "calendar",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/reservations`,
      },
    
      {
        title: "transactions",
        icon: "calendar",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/transactions`,
      },
    
      {
        title: "devices",
        icon: "board",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/devices`,
      },
    ]
  },
  {
    menutitle: "insights",
    menucontent: "Reports,Acitivity Logs",
    Items: [
      {
        title: "reports",
        icon: "calendar",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/reports`,
      },
      {
        title: "activity logs",
        icon: "file",
        type: "sub",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/activity-logs`,
      },
    ]
  },
  {
    menutitle: "configurations",
    menucontent: "Users,Venues,Settings",
    Items: [
      {
        title: "venues",
        icon: "project",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/venues`,
      },
      {
        title: "settings",
        icon: "editors",
        type: "sub",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/settings`,
      },
      {
        title: "users",
        icon: "user",
        type: "sub",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/users`,
      },
    ]
  }
];